import { defineComponent as _defineComponent } from 'vue'
import type { ContentCollection } from '@ilteducation/content-collections-types';
import { onBeforeMount, toRefs, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { getOne } from '@/data-provider/contentCollections';
import eventBus from '@/foundations/services/eventBus';

type Props = {
  id?: string;
  title: string;
  realm?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    realm: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  realm?: string;
}



const route = useRoute();

const item = ref<ContentCollection | undefined>();
onBeforeMount(async () => {
  const { realm } = route.query;
  try {
    item.value = await getOne(props.realm ?? realm, props.id);
  } catch (e) {
    console.error(e);
    eventBus.$emit('snackbarV2.open', { text: e, color: 'error' });
  }
});

return { __sfc: true,props, route, item }
}

})